import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage.service';
import { UserPreference } from './user-preference';

@Injectable()
export class UserPreferenceService {

  constructor(
    private localstor: LocalStorageService
  ) { }

  readonly StoreKey = "firstmediaSchedule.settings";

  Get(): UserPreference {
    try {
      let content: UserPreference = this.localstor.Get(this.StoreKey)

      if (content == null) {
        this.Reset();
        content = this.localstor.Get(this.StoreKey)
      }

      return content;
    } catch (error) {
      this.Reset();
      let content: UserPreference = this.localstor.Get(this.StoreKey)
      return content;
    }
  }

  Set(pref: UserPreference) {
    this.localstor.Set(this.StoreKey, pref);
  }

  Reset() {
    let ch1 = new UserPreference.Channel();
    ch1.Code = "1";
    ch1.Name = "BERITA SATU HD";
    ch1.LogoURL = "http://www.firstmedia.com/files/packages/BeritasatuCh1.png";

    let ch2 = new UserPreference.Channel();
    ch2.Code = "15";
    ch2.Name = "KOMPAS TV";
    ch2.LogoURL = "http://www.firstmedia.com/files/packages/kompas-new.png";

    let fav1 = new UserPreference.Favorite();
    fav1.Code = "favorite1";
    fav1.Channels = [ch1, ch2];

    let ch3 = new UserPreference.Channel();
    ch3.Code = "373";
    ch3.Name = "DISNEY HD";
    ch3.LogoURL = "http://www.firstmedia.com/files/packages/Disney+logo+baru.jpg";

    let ch4 = new UserPreference.Channel();
    ch4.Code = "328";
    ch4.Name = "FOX HD";
    ch4.LogoURL = "http://www.firstmedia.com/files/packages/FOX Channel Logo_Mono Orange.png";

    let fav2 = new UserPreference.Favorite();
    fav2.Code = "favorite2";
    fav2.Channels = [ch3, ch4];

    let content = new UserPreference();
    content.Favorites = [fav1, fav2];
    content.SelectedFavorite = 0;
    content.FilterPast = true;
    content.SelectedView = "master";
    content.UseAPIVersion = 3;
    this.Set(content);
  }

}



// WEBPACK FOOTER //
// D:/OTHERS/FirstmediaShowSchedule/src/app/user-preference/user-preference.service.ts